module.exports = {
    "id": "spores",
    "title": "spores",
    "image": "provision/parts/spores/spores.png",
    "info": [
      {
        "text": "Add spores to your project",
        "image": "provision/parts/spores/spores.png"
      }
    ],
    "exposedVariables": [],
    "codeImage": "provision/parts/spores/spores.png"
  } ;